import { ol_LayerBase, ol_layer } from "@omnia/exports/openlayers";
import { IOmniaSettings } from "../../types";
import { IBasemap, IBasemapGroup } from "../types";

export class BasemapGroup implements IBasemapGroup {

    private _basemap: IBasemap;
    private _visible: boolean;

    showKey = false

    constructor(
        public readonly key: string,
        public readonly basemaps: IBasemap[],
        private readonly layer: ol_LayerBase,
        private settings: IOmniaSettings,
        public readonly enableOpacity: boolean,
        public readonly custom: boolean,
        defaults?: {
            name?: string,
            visible?: boolean
        }) {

        defaults = defaults || {};

        this.restoreSettings(defaults.name, defaults.visible);

    }

    public activate() {

        if (this._basemap && this._visible) {
            this._basemap.setActive(true);
        }

    }

    public updateSize() {
        // NOP
    }

    get basemap(): IBasemap {
        return this._basemap;
    }

    set basemap(source: IBasemap) {

        if (this._basemap) {
            this._basemap.setActive(false);
        }

        this._basemap = source;

        if (this._basemap) {
            this._basemap.setActive(true);
        }

        this.settings.set("source", source.name);

    }

    get visible(): boolean {
        return this._visible;
    }

    set visible(value: boolean) {
        this.setBasemapVisibility(value, true);
    }

    get opacity(): number {
        return this.layer.getOpacity() * 100
    }

    set opacity(value: number) {
        this.layer.setOpacity(value / 100)
    }

    public setBasemap(basemap: IBasemap, save: boolean) {

        if (this._basemap) {
            this._basemap.setActive(false);
        }

        this._basemap = basemap;

        if (this._basemap) {
            this._basemap.setActive(true);
        }

        if (save) {
            this.settings.set("source", basemap.name);
        }

    }

    public setBasemapVisibility(visible: boolean, save: boolean) {

        this._visible = visible;

        if (this._basemap) {
            this._basemap.setActive(visible);
        }

        if (save) {
            this.settings.set("visible", visible, true);
        }

    }


    private restoreSettings(defaultName: string, defaultVisible: boolean) {

        let sourceName = this.settings.get("source", defaultName);
        let source = this.basemaps.find(m => m.name == sourceName);
        this.basemap = source || this.basemaps[0];

        this.setBasemapVisibility(this.settings.get("visible", defaultVisible), false);

    }


}
